import { dispatch } from "../state/store";
import {
  resetApps,
  resetConsentElements,
  resetConsents,
  resetMarkets,
  resetUsers,
  setConsentsMarket,
  setSelectedConsent
} from "../state/ducks";

const resetData = () => {
  dispatch(resetUsers());
  dispatch(resetMarkets());
  dispatch(resetConsents());
  dispatch(resetConsentElements());
  dispatch(setSelectedConsent(null));
  dispatch(setConsentsMarket(null));
  dispatch(resetApps());
};

const globalUtil = {
  resetData
};

export default globalUtil;
